export const serviceWorkerBroadcastChannelName = "glue42-core-worker";
export const platformPingTimeoutMS = 3000;
export const platformOpenTimeoutMS = 60000;

export const dbName = "glue42core";

export const dbVersion = 3;